interface IntuitionLogicStateChipProps {
    state?: string;
}

export function IntuitionLogicStateChip({ state }: IntuitionLogicStateChipProps) {
    const logicState = state?.toLowerCase();

    const iconMap: Record<string, { className: string }> = {
        running: { className: 'text-success fs-3 bi bi-play-circle-fill' },
        paused: { className: 'text-danger fs-3 bi bi-pause-circle-fill' },
        good_night_mode: { className: 'text-secondary fs-3 bi bi-moon-fill' }
    };

    const icon = iconMap[logicState ?? ''] ?? { className: 'text-muted fs-3 bi bi-question-circle-fill' };
    return <i className={icon.className}></i>;
}
